<template>
    <div class="mx-auto mt-5">
        <div id="header-identificacao" class="row bg-light mb-2">
            <div class="col-sm-12 col-md-6">
                <fieldset class="form-group">
                    <div role="group" class="bv-no-focus-ring">
                        <label for="devedor">Devedor:</label>
                        <input id="devedor" type="text" readonly="readonly" :value="nomeDevedorFormatado()"
                               class="font-weight-bold form-control-plaintext">
                    </div>
                </fieldset>
            </div>
            <div class="col-sm-12 col-md-6">
                <fieldset class="form-group">
                    <div role="group" class="bv-no-focus-ring">
                        <label>Tipo de TRP selecionado:</label>
                        <input type="text" readonly="readonly" :value="trp.tipoTrp.descricao" v-if="trp.tipoTrp"
                               class="font-weight-bold form-control-plaintext">
                    </div>
                </fieldset>
            </div>
        </div>

        <div class="row center-xy">
            <div class="col-md-10">&nbsp;</div>
            <div class="text-right mb-3 col-md-2">
                <b-button class="finish-button" variant="success" @click="concluir">
                    Concluir
                    <i class="fas fa-flag-checkered"></i>
                </b-button>
            </div>
        </div>

        <div class="mx-auto">
            <b-row>
                <b-col sm="12" md="12">
                    <b-list-group>
                        <b-list-group-item class="flex-column align-items-start">
                            <div class="d-flex w-100 justify-content-between">
                                <h3 class="app-title mb-1">TRP emitido:</h3>
                            </div>
                            <ul>
                                <li>
                                    TRP <b>{{retornoSalvar.id}}</b> emitido com sucesso.
                                </li>
                                <li>
                                    O termo emitido abrangeu a(s) seguinte(s) CDA's: <b>{{cdas()}}</b>
                                </li>
                            </ul>
                        </b-list-group-item>
                        <b-list-group-item class="flex-column align-items-start" v-if="retornoSalvar.arquivo != null">
                            <div class="d-flex w-100 justify-content-between">
                                <h3 class="app-title mb-1">TRP Emitida</h3>
                            </div>
                            <embed :src="`${urlApi}/v1/trp/obterArquivoTrp/publico/${retornoSalvar.id}/${retornoSalvar.arquivo}`"
                                    type="application/pdf"
                                    width="100%"
                                    height="400px"/>
                        </b-list-group-item>
                    </b-list-group>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        props: ['trp', 'retornoSalvar', 'nova', 'cdasSelecionadas'],
        data() {
            return {
                urlApi: null,
                urlPdf: null,
            }
        },
        methods: {
            nomeDevedorFormatado() {
                return this.trp.devedor.nome +
                    (this.trp.devedor.documento != null && this.trp.devedor.documento.length == 10 ? ' (CNPJ Raiz ' :
                        this.trp.devedor.documento != null && this.trp.devedor.documento.length <= 14 ? ' (CPF ' : ' (CNPJ ') +
                    this.trp.devedor.documento + ')';
            },
            cdas(){
                let cdas = "";

                for(let i = 0; i < this.cdasSelecionadas.length; i++) {
                    if(cdas != '') {
                        cdas += ', ';
                    }
                    cdas += this.cdasSelecionadas[i].numeroDivida;
                }

                return cdas;
            },

            concluir() {
                this.$router.push({path: '/home'});
            },
        },
        mounted() {
            this.urlApi = process.env.VUE_APP_ROOT_API;
        }
    }
</script>
<style>
</style>
